/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo upload
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Upload = kendo.ui.Upload;
    if (!Upload || Upload.updated) return;

    var SELECT_BUTTON = ".k-upload-button",
        DEFAULT_SELECT_CLASS = "secondary small",
        UPLOAD_BUTTON = ".k-upload-selected",
        oldWrapInput = Upload.fn._wrapInput,
        oldShowUplooadButton = Upload.fn._showUploadButton;

    /**
     * Provides a possibility to style select button via selectButtonClass option.
     */
    function newWrapInput(input) {
        var self = this,
            selectClass = $.trim(self.options.selectButtonClass || DEFAULT_SELECT_CLASS),
            $wrapper = oldWrapInput.call(self, input);
        if ($wrapper.length) $wrapper.find(SELECT_BUTTON).addClass(selectClass);
        return $wrapper;
    }

    /**
     * Provides a possibility to style upload button via uploadButtonClass option.
     */
    function newShowUploadButton() {
        var self = this,
            uploadClass = $.trim(self.options.uploadButtonClass || "");
        oldShowUplooadButton.call(self);
        if (uploadClass) $(UPLOAD_BUTTON, self.wrapper).addClass(uploadClass);
    }

    Upload = Upload.extend({
        // new init
        init: kendo.getGenericInit(Upload),
        // default options extension
        options: kendo.getUpdatedWidgetOptions({
            selectButtonClass: DEFAULT_SELECT_CLASS,
            uploadButtonClass: ""
        }),
        // updated methods
        _wrapInput: newWrapInput,
        _showUploadButton: newShowUploadButton
    });

    Upload.updated = true;

    kendo.ui.plugin(Upload);

})(window.kendo.jQuery);
